import { useState } from "react";
import {
    IconFolderPlus,
    IconPencil,
    IconListCheck,
    IconTrash,
    IconDownload,
    IconCheck,
    IconX,
    IconPhoto
} from "@tabler/icons-react";

const FolderSidebar = ({
    folders,
    activeFolderId,
    editingFolderId,
    onSelectFolder,
    onCreateFolder,
    onRenameFolder,
    onDeleteFolder,
    onStartEdit,
    onSaveEdit,
    onCancelEdit,
    zipBaseUrl
}) => {
    const [newFolderName, setNewFolderName] = useState("");
    const [renamingId, setRenamingId] = useState(null);
    const [renamingValue, setRenamingValue] = useState("");

    const handleCreate = (e) => {
        e.preventDefault();
        if (!newFolderName.trim()) return;
        onCreateFolder(newFolderName.trim());
        setNewFolderName("");
    };

    const startRenaming = (folder) => {
        setRenamingId(folder._id);
        setRenamingValue(folder.name);
    };

    const submitRename = (e) => {
        e.preventDefault();
        if (renamingValue.trim()) onRenameFolder(renamingId, renamingValue.trim());
        setRenamingId(null);
    };

    return (
        <div className="card">
            <div className="card-header">
                <h4 className="card-title">Folders</h4>
            </div>
            <div className="list-group list-group-flush">
                <button
                    type="button"
                    className={`list-group-item list-group-item-action d-flex align-items-center gap-2 ${!activeFolderId ? "active" : ""}`}
                    onClick={() => onSelectFolder(null)}
                >
                    <IconPhoto size={18} /> All Pictures
                </button>

                {folders.map((folder) => (
                    <div
                        key={folder._id}
                        className={`list-group-item ${activeFolderId === folder._id ? "active" : ""}`}
                    >
                        {renamingId === folder._id ? (
                            <form className="d-flex gap-2" onSubmit={submitRename}>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    autoFocus
                                    value={renamingValue}
                                    onChange={(e) => setRenamingValue(e.target.value)}
                                />
                                <button type="submit" className="btn btn-sm btn-icon"><IconCheck size={16} /></button>
                                <button type="button" className="btn btn-sm btn-icon" onClick={() => setRenamingId(null)}><IconX size={16} /></button>
                            </form>
                        ) : (
                            <div className="d-flex align-items-center justify-content-between gap-2">
                                <span
                                    className="pointer flex-fill"
                                    onClick={() => onSelectFolder(folder._id)}
                                >
                                    {folder.name} <small className="text-muted">({folder.pictureIds.length})</small>
                                </span>

                                {editingFolderId === folder._id ? (
                                    <div className="d-flex gap-1">
                                        <button type="button" className="btn btn-sm btn-success btn-icon" title="Save selection" onClick={onSaveEdit}><IconCheck size={16} /></button>
                                        <button type="button" className="btn btn-sm btn-icon" title="Cancel" onClick={onCancelEdit}><IconX size={16} /></button>
                                    </div>
                                ) : (
                                    <div className="d-flex gap-1">
                                        <button type="button" className="btn btn-sm btn-icon" title="Select pictures" onClick={() => onStartEdit(folder)}><IconListCheck size={16} /></button>
                                        <button type="button" className="btn btn-sm btn-icon" title="Rename" onClick={() => startRenaming(folder)}><IconPencil size={16} /></button>
                                        <a
                                            className="btn btn-sm btn-icon"
                                            title="Download as zip"
                                            href={`${zipBaseUrl}/folders/${folder._id}/zip`}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <IconDownload size={16} />
                                        </a>
                                        <button type="button" className="btn btn-sm btn-icon text-danger" title="Delete" onClick={() => onDeleteFolder(folder._id)}><IconTrash size={16} /></button>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                ))}
            </div>
            <div className="card-footer">
                <form className="d-flex gap-2" onSubmit={handleCreate}>
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="New folder name"
                        value={newFolderName}
                        onChange={(e) => setNewFolderName(e.target.value)}
                    />
                    <button type="submit" className="btn btn-sm btn-primary btn-icon"><IconFolderPlus size={16} /></button>
                </form>
            </div>
        </div>
    );
};

export default FolderSidebar;
